<!--
구매정보 상품 목록 — 간략 행 (공용 — TASK-161 사이클 13 #4 · #5 → 사이클 16 #27 간소화)
------------------------------------
 - 사용처 = 구매정보저장 모달 (batch/jobs/buy-request-store-order.vue — 「함께 저장되는 상품」) · 구매정보 수정 레이어 (buy-order/edit-layer.vue — readonly)
            · 대금상환 창고지급 · 정정 · 건별 정산확정 모달 (cod-payment/paid-popup · correct-popup · confirm-popup — readonly, card-class = cdp-popup-prod-card)
 - 사이클 16 #27 (사용자 — 「모달 상품정보가 너무 헤비하다, 주요 상품정보만 리스트」): 구 카드 (이미지 64 · 5줄) → 상품 1건 = 1행 (≈ 44px)
     열 = 썸네일 36 · 상품번호 · 상품 (브랜드 굵게 · 상품명 1줄 말줄임 — title = 쇼핑몰 · 브랜드 · 상품명) · 옵션 (색상 / 사이즈, 없으면 빈 칸)
          · 수량 × 구입단가 (통화 · 등폭 숫자 · 우측) · 배송단계 · 구분 칩 (readonly 아님 = 자동 포함 상품에만 「자동 포함」 — TASK-176: 「직접 선택」 칩 제거, 칸은 유지해 열 정렬 보존)
     행에서 제거 = 수취인 · 배송코드 · 트래킹번호 (트래킹은 모달 컨텍스트 헤더 app-buy-order-ctx 로) · 쇼핑몰 (상품명 title 툴팁)
     머리글 1줄 (회색 1rem) · 행 6개까지 자연 높이, 넘으면 이 목록 안에서만 스크롤 (머리글 고정 — 입력 폼은 밀리지 않음)
     표 (table) = 열 폭이 행끼리 · 머리글과 자동 정렬 (구 카드 div → tr)
 - 데이터 = store-order-preview API 의 prods 행 (StoreOrderPreviewLogic) / 대금상환 page.cod_rows[id].prods (CodPaymentIndexTrait::codPopupProds)
            — id · img_url · vender_mall · brand · name · color · size · amount · buy_unit_price · buy_unit_price_currency · state_text · selected
 - 자동 포함 행 강조 = 좌측 4px 바 (데이터 영역 배경색 변경 금지 — coding-conventions)
 - E2E 셀렉터 보존: 행 = card-class (구매정보저장 = br-store-prod-row · 대금상환 = cdp-popup-prod-card) · [data-prod-id]
                   · 칩 .br-store-pick > .br-store-pick-auto (자동 포함 행만, 직접 선택 행은 칩 없음. 전체 문구 「같은 오더번호 자동 포함」 = 화면 「자동 포함」 + 화면밖 접두)
                   · 상품번호 .br-store-prod-id
 - 글자 1rem 이상 (머리글 포함)
-->
<template>
    <div class="bo-prod-list">
        <div v-if="prods.length === 0" class="bo-prod-list__none">상품이 없습니다.</div>
        <table v-else class="bo-prod-table">
            <thead>
                <tr>
                    <th class="bo-prod-th-img"></th>
                    <th>상품번호</th>
                    <th>상품</th>
                    <th>옵션</th>
                    <th class="bo-prod-th-price">수량 × 단가</th>
                    <th>단계</th>
                    <th v-if="! readonly"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="p in prods" :key="p.id" class="bo-prod-row" :class="rowClasses(p)" :data-prod-id="p.id">
                    <td class="bo-prod-img">
                        <span class="bo-prod-thumb"><img v-if="p.img_url" :src="p.img_url" alt=""/></span>
                    </td>
                    <td class="bo-prod-id br-store-prod-id" title="상품번호">{{ p.id }}</td>
                    <td class="bo-prod-name-cell">
                        <div class="bo-prod-name" :title="nameTitle(p)">
                            <b v-if="filled(p.brand)" class="bo-prod-brand">{{ p.brand }}</b><span v-if="filled(p.brand) && filled(p.name)"> · </span>{{ filled(p.name) ? p.name : (filled(p.brand) ? '' : '—') }}
                        </div>
                    </td>
                    <td class="bo-prod-opt-cell"><div class="bo-prod-opt" :title="optText(p)">{{ optText(p) }}</div></td>
                    <td class="bo-prod-price">{{ amountText(p.amount) }} × {{ priceText(p.buy_unit_price, p.buy_unit_price_currency) }}</td>
                    <td class="bo-prod-state">{{ filled(p.state_text) ? p.state_text : '—' }}</td>
                    <td v-if="! readonly" class="bo-prod-pick-cell">
                        <span v-if="! p.selected" class="bo-prod-pick br-store-pick">
                            <span class="bo-prod-chip bo-prod-chip--auto br-store-pick-auto" title="같은 해외오더번호라서 자동으로 포함된 상품"><span class="bo-prod-sr">같은 오더번호 </span>자동 포함</span>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: {
            // 상품 행 목록 (store-order-preview prods / cod_rows[id].prods)
            prods: {
                type: Array,
                default: function () {
                    return [];
                },
            },

            // 읽기 전용 (구분 칩 열 숨김 — 수정 레이어 · 대금상환 모달)
            readonly: {
                type: Boolean,
                default: false,
            },

            // 행 추가 class (구매정보저장 모달 = br-store-prod-row · 대금상환 모달 = cdp-popup-prod-card — E2E 셀렉터 보존)
            cardClass: {
                type: String,
                default: '',
            },
        },
        methods: {
            rowClasses(p) {
                let classes = {
                    'is-auto': ! this.readonly && ! p.selected,
                };
                if (this.cardClass) {
                    classes[this.cardClass] = true;
                }
                return classes;
            },

            filled(val) {
                return ! (val === null || val === undefined || String(val).trim() === '');
            },

            // 상품명 툴팁 = 쇼핑몰 · 브랜드 · 상품명 (쇼핑몰은 행에서 제거 — 사이클 16 #27)
            nameTitle(p) {
                return [p.vender_mall, p.brand, p.name].filter((v) => this.filled(v)).join(' · ');
            },

            // 옵션 = 색상 / 사이즈 (빈 값 생략 — 둘 다 없으면 빈 칸)
            optText(p) {
                return [p.color, p.size].filter((v) => this.filled(v)).join(' / ');
            },

            amountText(val) {
                return this.filled(val) ? val : '—';
            },

            // 금액 표시 (JPY 소수점 없음)
            priceText(val, currency) {
                let num = parseFloat(val);
                if (isNaN(num)) {
                    return '—';
                }
                let digits = currency === 'JPY' ? 0 : 2;
                return (currency ? currency + ' ' : '') + this.$formatNumber(num, digits);
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 사이클 16 #27 — 간략 행 목록. 높이 = 머리글 + 6행까지 자연 (행 ≈ 44px = 썸네일 36 + 상하 4), 넘으면 목록 안 스크롤
    .bo-prod-list {
        max-height: 300px;
        overflow: auto;
        border: 1px solid #d7dbe2;
        border-radius: 6px;
        background: #fff;
        font-size: 1rem;
    }

    .bo-prod-list__none {
        padding: 10px 0;
        color: #888;
        text-align: center;
    }

    .bo-prod-table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;

        th,
        td {
            padding: 4px 8px;
            border-bottom: 1px solid #eef0f3;
            vertical-align: middle;
            white-space: nowrap;
            text-align: left;
        }

        // 머리글 = 회색 1rem (스크롤해도 고정)
        th {
            position: sticky;
            top: 0;
            z-index: 1;
            padding-top: 3px;
            padding-bottom: 3px;
            border-bottom-color: #d7dbe2;
            background: #f7f8fa;
            color: #6b7280;
            font-size: 1rem;
            font-weight: 400;
            text-transform: none;
        }

        tbody tr:last-child td {
            border-bottom: 0;
        }

        .bo-prod-th-price {
            text-align: right;
        }
    }

    // 같은 오더번호 자동 포함 = 좌측 4px 바 (배경 변경 없음 — 첫 칸에 그림)
    .bo-prod-row.is-auto > td:first-child {
        box-shadow: inset 4px 0 0 #1e87f0;
    }

    .bo-prod-img {
        width: 36px;
        padding-right: 4px !important;
    }

    .bo-prod-thumb {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        overflow: hidden;
        border: 1px solid #eef0f3;
        border-radius: 4px;
        background: #fafbfc;

        img {
            max-width: 36px;
            max-height: 36px;
            object-fit: contain;
        }
    }

    .bo-prod-id {
        font-family: "IBM Plex Mono", ui-monospace, monospace;
        font-weight: 700;
        color: #111;
    }

    // 상품 칸 = 남는 폭 전부 + 1줄 말줄임 (max-width 0 = 표 자동 폭 계산에서 내용 길이 무시)
    .bo-prod-name-cell {
        width: 100%;
        max-width: 0;
    }

    .bo-prod-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #222;
    }

    .bo-prod-brand {
        color: #2b3a55;
    }

    // 옵션 = 최대 8rem 1줄 말줄임 (표 칸 max-width 는 자동 폭 표에서 무시되므로 안쪽 div 에 지정)
    .bo-prod-opt {
        max-width: 8rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #6b7280;
    }

    .bo-prod-price {
        text-align: right !important;
        font-variant-numeric: tabular-nums;
        color: #222;
    }

    .bo-prod-state {
        color: #6b7280;
    }

    .bo-prod-pick-cell {
        text-align: right !important;
    }

    .bo-prod-chip {
        display: inline-flex;
        align-items: center;
        padding: 0 8px;
        border: 1px solid #c9ced6;
        border-radius: 3px;
        background: #fff;
        color: #444;
        line-height: 1.55rem;
        white-space: nowrap;

        &--auto {
            border-color: #1e87f0;
            color: #1565c0;
        }
    }

    // 화면밖 접두 (칩 전체 문구 「같은 오더번호 자동 포함」 = E2E · 스크린리더용, 화면 = 「자동 포함」)
    .bo-prod-sr {
        position: absolute;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }
</style>
